import styled from "styled-components";

export const TutorialContainer = styled.div`
  background-color: #03151f;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 100%;
  padding: 80px 10px 98px 50px;
  position: relative;
  width: 450px;
`;

export const InnerContainer = styled.div`
  align-items: center;
  border: 1px solid grey;
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.075);
  display: flex;
  flex-direction: column;
  height: 500px;
  justify-content: center;
`;

export const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 230px;
  justify-content: center;
  width: 100%;
`;

export const TextContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  margin-top: 20px;
  p {
    color: white;
    font-weight: 200;
  }
`;

export const ContentContainer = styled.div`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
`;

export const Header = styled.h2`
  color: white;
`;

export const DotsContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 20px;
  justify-content: center;
  width: 100%;
`;

export const Dot = styled.div`
  background-color: ${({ active }) => (active ? "white" : "black")};
  border-radius: 50%;
  height: 8px;
  margin: 0 2px;
  transform: translateY(20px);
  transition: background-color 0.7s ease-in-out;
  width: 8px;
`;
